module.exports = __webpack_public_path__ + "static/img/y33.99e88f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y33.jpg
// module id = h0Fk
// module chunks = 1